import React from 'react';
import { Box, capitalize, styled, Typography } from '@mui/material';
import { MAvatar } from 'src/minimals/@material-extend';
import _ from 'lodash';
import { Icon } from '@iconify/react';
import roundViewPhoto from '@iconify/icons-ic/round-visibility';

const ProfileStyle = styled('div')(({ theme, profileStyle = {} }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 0),
  minWidth: 100,
  '&:hover .avatar-hover-overlay': {
    opacity: 0.84,
    pointerEvents: 'auto',
  },
  ...profileStyle,
}));

const HoverOverlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  opacity: 0,
  pointerEvents: 'none',
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  cursor: 'pointer',
}));

const AvatarCell = ({
  name,
  title,
  titleComponent,
  subtitle,
  avatarStyle,
  avatarProps,
  avatarSource,
  onViewAvatar,
  profileStyle,
}) => (
  <ProfileStyle profileStyle={profileStyle}>
    <Box sx={{ position: 'relative', width: 24, height: 24 }}>
      <MAvatar
        sx={{ width: 24, height: 24, ...avatarStyle }}
        {...avatarProps}
        src={avatarSource || ''}
      >
        {_.isEmpty(avatarSource) && (
          <Box fontSize={12}>{capitalize(name || 'no name')}</Box>
        )}
      </MAvatar>
      {!_.isEmpty(avatarSource) && _.isFunction(onViewAvatar) && (
        <HoverOverlay
          role="button"
          tabIndex={0}
          className="avatar-hover-overlay"
          onClick={onViewAvatar}
          onKeyPress={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              onViewAvatar(event);
            }
          }}
        >
          <Icon icon={roundViewPhoto} width={18} height={18} />
        </HoverOverlay>
      )}
    </Box>
    <Box sx={{ ml: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {!_.isEmpty(titleComponent) ? (
        <>{titleComponent}</>
      ) : (
        <Typography variant="subtitle2" sx={[{ fontSize: 12 }]}>
          {title || 'no title'}
        </Typography>
      )}

      {!_.isEmpty(subtitle) && (
        <Typography variant="subtitle2" sx={[{ fontSize: 11 }]}>
          {subtitle}
        </Typography>
      )}
    </Box>
  </ProfileStyle>
);

export default AvatarCell;
